import { isDev } from '../../global/config/is-dev';
import { isStaging } from '../../global/config/is-staging';

export function getSubDomain(location: string) {
  const locationParts = location.split('.');
  let sliceTill = -2;

  if (isDev) sliceTill = -1;
  if (isStaging) sliceTill = -3;
  return locationParts.slice(0, sliceTill).join('');
}
